import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  PageHeader,
  PageTitle,
  DropdownContainer,
  DropdownButton,
  DropdownMenu,
  DropdownItem,
  TabsContainer,
  TabsList,
  Tab,
  TabContent,
  ChevronIcon,
} from "../../styles/MenuManagement.styled";
import BundleDeal from "./BundleDeal";
import FoodPage from "./FoodPage";
import {
  InventoryHeader,
  InventoryStatBox,
  StatLabel,
  StatValue,
} from "../../styles/FoodPage.styles";
import { refreshHeaderOptionToken } from "../../utils/apis/api-header-option";
import { apiURL_provider, ROUTES } from "../../constants";
import axios from "axios";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { DashboardContainer } from "../../styles/dashboard";
import { useSidebar } from "../../context/SidebarContext";
import { LoadingOverlay,LoadingSpinner,LoadingSpinnerIcon } from "../../styles/loading";

const MenuManagement: React.FC = () => {
  const navigate = useNavigate();
  const { isSidebarCollapsed } = useSidebar();
  
  const [activeTab, setActiveTab] = useState("food-menu");
  const [values, setValues] = React.useState<any>({
    display: {
      id: -1,
      totalProduct: 0,
      category: 0,
      stockCount: 0,
    },
  });
  const [loading, setLoading] = React.useState(false);
  const [showAddDropdown, setShowAddDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const selected_menu_tab = localStorage.getItem("selected_menu_tab") || "";
    if (selected_menu_tab) {
      setActiveTab(selected_menu_tab);
    }
  }, []);

  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "null");
    if (authUser) {
      setLoading(true);
      getDataCount(authUser.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowAddDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getDataCount = (id: any, page = 1) => {
    let headers = refreshHeaderOptionToken();
    let url = "fooddelivery/GetTotalCountsByServiceProviderId";
    let param = {
      serviceProviderId: id.toString(),
    };
    axios
      .post(`${apiURL_provider}/${url}`, param, {
        headers: headers.option,
      })
      .then(({ data }) => {
        try {
          let tempDisplay = values.display;
          tempDisplay.category = data.categoryTotalCount;
          tempDisplay.totalProduct = data.productTotalCount;

          setValues({
            ...values,
            display: tempDisplay,
          });
          setLoading(false);

        } catch {
          setLoading(false);
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const handleTabChange = (tabId: string) => {
    setActiveTab(tabId);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "food-menu":
        return <FoodPage />;
      case "bundle-deal":
        return <BundleDeal />;
      default:
        return <FoodPage />;
    }
  };

  return (
    <>
        {loading && (
                <LoadingOverlay>
                  <LoadingSpinner>
                    <LoadingSpinnerIcon />
                  </LoadingSpinner>
                </LoadingOverlay>
              )}
          <DashboardContainer $isSidebarCollapsed={isSidebarCollapsed}>
    
      <PageHeader>
        <PageTitle>Food Inventory</PageTitle>
        <DropdownContainer ref={dropdownRef}>
          <DropdownButton onClick={() => setShowAddDropdown(!showAddDropdown)}>
            Add Menu
            <ChevronIcon $isExpanded={showAddDropdown}>
            <KeyboardArrowDownIcon />
            </ChevronIcon>
          </DropdownButton>
          {showAddDropdown && (
            <DropdownMenu $isOpen={showAddDropdown}>
              <DropdownItem 
                onClick={() => {
                  navigate(ROUTES.ADD_NEW_FOOD_MENU.replace(":id", "-1"));
                  setShowAddDropdown(false);
                }}
              >
                Add Food Item
              </DropdownItem>
              <DropdownItem 
                onClick={() => {
                  navigate(ROUTES.ADD_NEW_BUNDLE_DEAL.replace(":id", "-1"));
                  setShowAddDropdown(false);
                }}
              >
                Add Bundle
              </DropdownItem>
            </DropdownMenu>
          )}
        </DropdownContainer>
      </PageHeader>

      <InventoryHeader>
        <InventoryStatBox>
          <StatLabel className="mb-16">Total Food Menus</StatLabel>
          <StatValue color="#5BA43B">
            {values.display?.totalProduct || 0}
          </StatValue>
        </InventoryStatBox>
        <InventoryStatBox>
          <StatLabel className="mb-16">Categories</StatLabel>
          <StatValue color="#5BA43B">{values.display?.category || 0}</StatValue>
        </InventoryStatBox>
      </InventoryHeader>

      <TabsContainer>
        <TabsList>
          <Tab
            $isActive={activeTab === "food-menu"}
            onClick={() => handleTabChange("food-menu")}
          >
            Food Menu
          </Tab>
          <Tab
            $isActive={activeTab === "bundle-deal"}
            onClick={() => handleTabChange("bundle-deal")}
          >
            Bundle Deal
          </Tab>
        </TabsList>
      </TabsContainer>

      <TabContent>{renderTabContent()}</TabContent>
    </DashboardContainer>
    </>
  );
};

export default MenuManagement;
